import React from 'react';
import './Chapters.scss';

function Chapter2() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          “We start collecting data before the seed is even planted,” says Francesco Oliveri,
          Perfection’s Chief Information Officer, “Everything from varietal research and development
          to meteorological and soil conditions on Perfection's many farms. And our success depends
          on understanding the data, bringing it together, and building the appropriate
          infrastructure to act on it.” To build this infrastructure, Oliveri would come to partner
          with{' '}
          <a
            href="https://www.lenovo.com/us/en/servers-storage/"
            target="_blank"
            rel="sponsored"
            style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
          >
            Lenovo Enterprise Solutions
          </a>{' '}
          to craft a system capable of handling Perfection’s ever-evolving challenges—including
          having enough computing power to process all that data and provide the right insights.
        </p>
      </section>
    </>
  );
}

export default Chapter2;
